<div class="profile-wrapper">
	<div class="page-container">
		<section>
			<div class="row">
				<div class="col">
					<h2 [translate]="'account.profile.title'">MY ACCOUNT</h2>
				</div>
			</div>
		</section>
	</div>

	<div class="page-container" *ngIf="isProfileLoaded">
		<section>
			<form [formGroup]="updatePersonalInfoForm">
				<div class="row">
					<div class="col-md-12 title-with-btn">
						<h4 class="float-left" [translate]="'account.profile.sections.personal-information.title'">
							PERSONAL INFORMATION
						</h4>
						<div class="float-right">
							<div *ngIf="!isPersonalInfoEditable">
								<button
									class="button secondary-btn button-medium"
									mat-stroked-button
									appEheAnalytics
									[data]="analyticsData"
									(click)="updatePersonalInfo()">
									<span [translate]="'account.profile.sections.form.edit-button'">EDIT</span>
								</button>
							</div>
							<div class="button-group" *ngIf="isPersonalInfoEditable">
								<button
									class="button secondary-btn button-medium"
									mat-stroked-button
									appEheAnalytics
									[data]="analyticsData"
									(click)="cancelUpdatePersonalInfo()">
									<span [translate]="'account.profile.sections.form.cancel-button'">CANCEL</span>
								</button>
								<button
									class="button button-medium"
									mat-button
									appEheAnalytics
									[data]="analyticsData"
									(click)="savePersonalInfo()">
									<span [translate]="'account.profile.sections.form.save-button'">SAVE</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<div class="row">
							<div class="col" *ngIf="isPersonalInfoEditable">
								<mat-form-field class="form-group">
									<mat-label>{{
										'account.profile.sections.personal-information.form.first-name' | translate
									}}</mat-label>
									<input matInput formControlName="firstName" required />
									<app-error-message [control]="'firstName'"></app-error-message>
								</mat-form-field>
							</div>
							<div class="col no-editable" *ngIf="!isPersonalInfoEditable">
								<span [translate]="'account.profile.sections.personal-information.form.first-name'">First Name</span>
								<span class="text-16">{{ profileInfoBean.firstName }}</span>
							</div>
							<div class="col" *ngIf="isPersonalInfoEditable">
								<mat-form-field class="form-group">
									<mat-label>{{
										'account.profile.sections.personal-information.form.last-name' | translate
									}}</mat-label>
									<input matInput formControlName="lastName" required />
									<app-error-message [control]="'lastName'"></app-error-message>
								</mat-form-field>
							</div>
							<div class="col no-editable" *ngIf="!isPersonalInfoEditable">
								<span [translate]="'account.profile.sections.personal-information.form.last-name'">Last Name</span>
								<span class="text-16">{{ profileInfoBean.lastName }}</span>
							</div>
						</div>
						<div class="row">
							<div class="col" *ngIf="isPersonalInfoEditable">
								<mat-form-field class="form-group">
									<mat-label>{{ 'account.profile.sections.personal-information.form.dob' | translate }}</mat-label>
									<input matInput [matDatepicker]="picker" formControlName="dateOfBirth" required [max]="maxDate" />
									<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
									<mat-datepicker #picker></mat-datepicker>
									<app-error-message [control]="'dateOfBirth'"></app-error-message>
								</mat-form-field>
							</div>
							<div class="col no-editable" *ngIf="!isPersonalInfoEditable">
								<span [translate]="'account.profile.sections.personal-information.form.dob'">DOB</span>
								<span class="text-16">{{ getDate(profileInfoBean.dateOfBirth) }}</span>
							</div>
							<div class="col" *ngIf="isPersonalInfoEditable">
								<mat-form-field class="form-group">
									<mat-label>Assigned Gender at Birth</mat-label>
									<mat-select
										disableOptionCentering
										panelClass="custom-material-position"
										formControlName="gender"
										required>
										<mat-option [value]="'MALE'">
											<span [translate]="'account.profile.sections.personal-information.form.male'">Male</span>
										</mat-option>
										<mat-option [value]="'FEMALE'">
											<span [translate]="'account.profile.sections.personal-information.form.female'">Female</span>
										</mat-option>
									</mat-select>
									<app-error-message [control]="'gender'"></app-error-message>
								</mat-form-field>
							</div>
							<div class="col no-editable" *ngIf="!isPersonalInfoEditable">
								<span [translate]="'account.profile.sections.personal-information.form.gender-at-birth'">
									Assigned Gender at Birth
								</span>
								<span class="text-16 text-capitalize">{{ profileInfoBean.gender.toLowerCase() }}</span>
							</div>
						</div>
						<div class="row">
							<div class="col" *ngIf="isPersonalInfoEditable">
								<mat-form-field class="form-group">
									<mat-label>{{
										'account.profile.sections.personal-information.form.cellnumber' | translate
									}}</mat-label>
									<input matInput formControlName="cellPhone" [imask]="phoneMask.iMaskArgs" />
									<app-error-message [control]="'cellPhone'"></app-error-message>
								</mat-form-field>
							</div>
							<div class="col no-editable" *ngIf="!isPersonalInfoEditable">
								<span [translate]="'account.profile.sections.personal-information.form.cellnumber'">Cell Phone</span>
								<span class="text-16">{{ profileInfoBean.cellPhone | maskPhone }}</span>
							</div>
							<div class="col" *ngIf="isPersonalInfoEditable">
								<mat-form-field class="form-group">
									<mat-label>{{ 'account.profile.sections.personal-information.form.employer' | translate }}</mat-label>
									<input matInput formControlName="employer" required />
									<app-error-message [control]="'employer'"></app-error-message>
								</mat-form-field>
							</div>
							<div class="col no-editable" *ngIf="!isPersonalInfoEditable">
								<span [translate]="'account.profile.sections.personal-information.form.employer'">Employer</span>
								<span class="text-16">{{ profileInfoBean?.client?.name }}</span>
							</div>
						</div>
						<div class="row">
							<div class="col" *ngIf="isPersonalInfoEditable">
								<mat-form-field class="form-group">
									<mat-label>{{ 'account.profile.sections.personal-information.form.address' | translate }}</mat-label>
									<input matInput formControlName="address" required />
									<app-error-message [control]="'address'"></app-error-message>
								</mat-form-field>
							</div>
							<div class="col no-editable" *ngIf="!isPersonalInfoEditable">
								<span [translate]="'account.profile.sections.personal-information.form.address'">Address Line 1</span>
								<span class="text-16">{{ profileInfoBean.address }}</span>
							</div>
							<div class="col" *ngIf="isPersonalInfoEditable">
								<mat-form-field class="form-group">
									<mat-label>Address Line 2</mat-label>
									<input matInput formControlName="address2" />
									<app-error-message [control]="'address2'"></app-error-message>
								</mat-form-field>
							</div>
							<div class="col no-editable" *ngIf="!isPersonalInfoEditable">
								<span>Address Line 2</span>
								<span class="text-16">{{ profileInfoBean.address2 }}</span>
							</div>
						</div>
						<div class="row">
							<div class="col" *ngIf="isPersonalInfoEditable">
								<mat-form-field class="form-group">
									<mat-label>{{ 'account.profile.sections.personal-information.form.city' | translate }}</mat-label>
									<input matInput formControlName="city" required />
									<app-error-message [control]="'city'"></app-error-message>
								</mat-form-field>
							</div>
							<div class="col no-editable" *ngIf="!isPersonalInfoEditable">
								<span [translate]="'account.profile.sections.personal-information.form.city'">City</span>
								<span class="text-16">{{ profileInfoBean.city }}</span>
							</div>
							<div class="col">
								<div class="row">
									<mat-form-field class="col-6" *ngIf="isPersonalInfoEditable">
										<mat-label>{{ 'account.profile.sections.personal-information.form.state' | translate }}</mat-label>
										<mat-select
											disableOptionCentering
											panelClass="custom-material-position"
											formControlName="state"
											required>
											<ng-container *ngFor="let state of states">
												<mat-option [value]="state">{{ state }}</mat-option>
											</ng-container>
										</mat-select>
										<app-error-message [control]="'state'"></app-error-message>
									</mat-form-field>
									<div class="col-6 no-editable" *ngIf="!isPersonalInfoEditable">
										<span [translate]="'account.profile.sections.personal-information.form.state'">State</span>
										<span class="text-16">{{ profileInfoBean.state }}</span>
									</div>
									<mat-form-field class="col-6" *ngIf="isPersonalInfoEditable">
										<mat-label>{{ 'account.profile.sections.personal-information.form.zip' | translate }}</mat-label>
										<input matInput formControlName="zipCode" [imask]="zipMask.iMaskArgs" required />
										<app-error-message [control]="'zipCode'"></app-error-message>
									</mat-form-field>
									<div class="col-6 no-editable" *ngIf="!isPersonalInfoEditable">
										<span [translate]="'account.profile.sections.personal-information.form.zip'">Zipcode</span>
										<span class="text-16">{{ profileInfoBean.zipCode }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</section>
	</div>
	<div class="page-container" *ngIf="isEmailLoaded">
		<section>
			<form [formGroup]="updateEmailInfoForm">
				<div class="row">
					<div class="col-md-12 title-with-btn">
						<h4 class="float-left" [translate]="'account.profile.sections.email-addresses.title'">EMAIL</h4>
						<div class="float-right">
							<div *ngIf="!isEmailEditable">
								<button
									class="button secondary-btn button-medium"
									mat-stroked-button
									appEheAnalytics
									[data]="analyticsData"
									(click)="updateEmail()">
									<span [translate]="'account.profile.sections.form.edit-button'">EDIT</span>
								</button>
							</div>
							<div class="button-group" *ngIf="isEmailEditable">
								<button
									class="button secondary-btn button-medium"
									mat-stroked-button
									appEheAnalytics
									[data]="analyticsData"
									(click)="cancelUpdateEmail()">
									<span [translate]="'account.profile.sections.form.cancel-button'">CANCEL</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<ng-container *ngIf="!isEmailEditable">
							<div class="row">
								<div class="col-6 no-editable">
									<span [translate]="'account.profile.sections.email-addresses.form.preferred-primary-email'">
										Preferred Email (Sign In)
									</span>
									<span class="text-16">{{ primaryEmail.email }}</span>
								</div>
							</div>
							<ng-container *ngIf="additionalEmails && additionalEmails.length > 0">
								<div class="row">
									<div class="col-6 no-editable">
										<span>Additional Email</span>
										<ng-container *ngFor="let email of additionalEmails">
											<div class="text-16">{{ email.email }}</div>
										</ng-container>
									</div>
								</div>
							</ng-container>
						</ng-container>
						<div class="row">
							<div class="col-12" *ngIf="isEmailEditable">
								<mat-form-field class="form-group">
									<mat-label>{{
										'account.profile.sections.email-addresses.form.preferred-email' | translate
									}}</mat-label>
									<input class="width-80" matInput formControlName="primaryEmail" />
									<div class="controls text-10">
										<span
											*ngIf="
												updateEmailInfoForm.controls.primaryEmail.dirty &&
												updateEmailInfoForm.controls.primaryEmail.value.length !== 0 &&
												updateEmailInfoForm.controls.primaryEmail.errors === null
											"
											class="email-text"
											tabindex="-1"
											(keypress)="verifyEmailAddress()"
											(click)="verifyEmailAddress()"
											appEheAnalytics
											[data]="analyticsData"
											>Update</span
										>
									</div>
									<mat-hint>
										<span
											*ngIf="!additionalEmails || additionalEmails?.length === 0"
											class="email-text"
											(click)="addNewAdditionalEmail()"
											appEheAnalytics
											[data]="analyticsData"
											>Add Email Address</span
										>
									</mat-hint>
									<app-error-message [control]="'primaryEmail'"></app-error-message>
								</mat-form-field>

								<div formArrayName="emails">
									<div
										*ngFor="
											let email of updateEmailInfoForm.controls.emails.controls;
											let i = index;
											let isLast = last
										">
										<mat-form-field class="form-group" [formGroupName]="i">
											<mat-label>{{
												'account.profile.sections.email-addresses.form.additional-email' | translate
											}}</mat-label>
											<input class="width-80" matInput formControlName="email" />
											<div class="controls text-10">
												<span
													*ngIf="email.dirty && email.status === 'VALID' && email.value.email?.length !== 0"
													class="email-text"
													(click)="verifyEmailAddress(i)"
													appEheAnalytics
													[data]="analyticsData"
													[translate]="'account.profile.sections.email-addresses.form.verify-email'"
													>Update</span
												>
												<span
													*ngIf="!additionalEmails[i].isNew && !fromSso"
													class="email-text"
													(click)="makePrimary(i)"
													appEheAnalytics
													[data]="analyticsData"
													[translate]="'account.profile.sections.email-addresses.form.make-primary'"
													>Make Preferred</span
												>
												<span
													*ngIf="!additionalEmails[i].isNew"
													class="email-text"
													(click)="removeAdditionalEmail(i)"
													appEheAnalytics
													[data]="analyticsData"
													[translate]="'account.profile.sections.email-addresses.form.remove-email'"
													>Remove</span
												>
											</div>
											<app-error-message [control]="'emails'"></app-error-message>
											<mat-hint>
												<span
													*ngIf="isLast && canAddNewEmail"
													class="email-text"
													(click)="addNewAdditionalEmail()"
													appEheAnalytics
													[data]="analyticsData">
													Add Email Address
												</span>
											</mat-hint>
										</mat-form-field>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</section>
	</div>
	<div class="page-container" *ngIf="!fromSso">
		<section>
			<form [formGroup]="updateSecurityInfoForm">
				<div class="row">
					<div class="col-md-12 title-with-btn">
						<h4 class="float-left" [translate]="'account.profile.sections.security.title'">PASSWORD</h4>
						<div class="float-right">
							<div *ngIf="!isSecurityInfoEditable">
								<button
									class="button secondary-btn button-medium"
									mat-stroked-button
									appEheAnalytics
									[data]="analyticsData"
									(click)="updateSecurityInfo()">
									<span [translate]="'account.profile.sections.form.edit-button'">EDIT</span>
								</button>
							</div>
							<div class="button-group" *ngIf="isSecurityInfoEditable">
								<button
									class="button secondary-btn button-medium"
									mat-stroked-button
									appEheAnalytics
									[data]="analyticsData"
									(click)="cancelUpdateSecurityInfo()">
									<span [translate]="'account.profile.sections.form.cancel-button'">CANCEL</span>
								</button>
								<button
									class="button button-medium"
									mat-button
									(click)="saveSecurityInfo(); hidePasswordStrengthBlock = true"
									appEheAnalytics
									[data]="analyticsData">
									<span [translate]="'account.profile.sections.form.save-button'">SAVE</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<div class="row">
							<div class="col-8" *ngIf="isSecurityInfoEditable">
								<mat-form-field class="form-group">
									<mat-label>{{ 'account.profile.sections.security.form.old-password' | translate }}</mat-label>
									<input
										matInput
										formControlName="oldPassword"
										type="password"
										appShowHidePassword
										maxlength="32"
										(focusin)="hidePasswordStrengthBlock = true" />
									<app-error-message [control]="'oldPassword'"></app-error-message>
								</mat-form-field>
								<div class="password-wrapper">
									<mat-form-field class="form-group">
										<mat-label>{{ 'account.profile.sections.security.form.new-password' | translate }}</mat-label>
										<input
											#password
											matInput
											formControlName="password"
											type="password"
											appShowHidePassword
											maxlength="32"
											(focusin)="hidePasswordStrengthBlock = false" />
									</mat-form-field>
									<div class="strength-wrapper {{ hidePasswordStrengthBlock ? 'hide' : '' }}">
										<mat-hint class="hint" align="end" aria-live="polite"> {{ password.value.length }} / 32 </mat-hint>
										<mat-password-strength
											#passwordComponent
											[password]="password.value"
											[enableLengthRule]="true"
											[enableSpecialCharRule]="false"
											[customValidator]="passwordSpecialCharsValidatorRegExp"></mat-password-strength>
										<password-strength-info
											[passwordComponent]="passwordComponent"
											digitsCriteriaMsg="{{ 'shared.password.digits-rule' | translate }}"
											upperCaseCriteriaMsg="{{ 'shared.password.uppercase-rule' | translate }}"
											lowerCaseCriteriaMsg="{{ 'shared.password.lowercase-rule' | translate }}"
											customCharsCriteriaMsg="{{ 'shared.password.special-character-rule' | translate }}">
										</password-strength-info>
									</div>
								</div>
								<mat-form-field class="form-group">
									<mat-label>Confirm Password</mat-label>
									<input
										matInput
										type="password"
										formControlName="confirmPassword"
										appShowHidePassword
										maxlength="32"
										(focusin)="hidePasswordStrengthBlock = true" />
									<app-error-message [control]="'confirmPassword'"></app-error-message>
								</mat-form-field>
							</div>
							<div class="col-6 no-editable" *ngIf="!isSecurityInfoEditable">
								<span [translate]="'account.profile.sections.security.form.password'">Password</span>
								<span class="text-16">{{ getHash('xxxxxxxx') }}</span>
							</div>
						</div>
					</div>
				</div>
			</form>
		</section>
	</div>
	<div *ngIf="getGlobalMfaStatus()" id="mfa-settings" class="page-container">
		<div class="row">
			<div class="col-sm-10">
				<h2 class="float-left">TWO-FACTOR SIGN IN</h2>
			</div>
			<div class="col-sm-2">
				<div class="custom-control custom-switch switch-control">
					<input
						type="checkbox"
						class="custom-control-input"
						id="customSwitch"
						[checked]="getUserMfaStatus()"
						(click)="updateMfaPreferences($event)" />
					<label class="custom-control-label" for="customSwitch">
						{{ getUserMfaStatus() ? 'ON' : 'OFF' }}
					</label>
				</div>
			</div>
		</div>
		<br />
		<div class="row">
			<div class="col-sm-11">
				Two-factor sign in provides an additional layer of security for your myEHE account.<br />
				When signing in to myEHE, a security code will be sent to your preferred email address, shown above.
			</div>
		</div>
	</div>
	<!-- TODO: Uncomment.. Preferences are not required for this MVP  -->
	<div class="page-container" *ngIf="false">
		<section>
			<form [formGroup]="updatePreferencesForm">
				<div class="row">
					<div class="col">
						<h4 class="primary-color-text" [translate]="'account.profile.sections.preferences.title'">PREFERENCES</h4>
					</div>
					<div class="col-md-auto" *ngIf="!isPreferencesEditable">
						<button class="button secondary-btn button-medium" mat-stroked-button (click)="updatePreferences()">
							<span [translate]="'account.profile.sections.form.edit-button'">EDIT</span>
						</button>
					</div>
					<div class="col-md-auto button-group" *ngIf="isPreferencesEditable">
						<button class="button secondary-btn button-medium" mat-stroked-button (click)="cancelUpdatePreferences()">
							<span [translate]="'account.profile.sections.form.cancel-button'">CANCEL</span>
						</button>
						<button class="button button-medium" mat-button (click)="savePreferences()">
							<span [translate]="'account.profile.sections.form.save-button'">SAVE</span>
						</button>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 no-editable">
						<h6 [translate]="'account.profile.sections.preferences.form.notification-settings.title'">
							Notification Settings
						</h6>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<mat-checkbox formControlName="emailNotification">
										<span [translate]="'account.profile.sections.preferences.form.email-notifications'">
											I want to receive email notifications.
										</span>
									</mat-checkbox>
									<app-error-message [control]="'emailNotification'"></app-error-message>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<mat-checkbox formControlName="smsNotification">
										<span [translate]="'account.profile.sections.preferences.form.sms-notifications'">
											I want to receive SMS text notifications.
										</span>
									</mat-checkbox>
									<app-error-message [control]="'smsNotification'"></app-error-message>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 no-editable">
						<h6 [translate]="'account.profile.sections.preferences.form.ehe-health-news.title'">EHE Health News</h6>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<mat-checkbox formControlName="receiveHealthNews">
										<span [translate]="'account.profile.sections.preferences.form.receive-health-news'">
											I want to subscribe to EHE Health news.
										</span>
									</mat-checkbox>
									<app-error-message [control]="'receiveHealthNews'"></app-error-message>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</section>
	</div>
</div>
